export default __webpack_public_path__ + "static/media/donacion_recurrente.d73852cb.png";